import api from "../api/programs";
import {createError, logError, logSuccess} from "./message";
import {getFullProgram, getProgram, getProgramHtmlAnounce, getProgramHtmlDescription} from "./actions";
import types from "./types";

function updateProgramLogoRequest() {
  return {
    type: types.UPDATE_PROGRAM_LOGO_REQUEST,
    isUpdatingLogo: true
  };
}

function updateProgramLogoCompleted(updatedLogo) {
  return {
    type: types.UPDATE_PROGRAM_LOGO_COMPLETED,
    isUpdatingLogo: false,
    updatedLogo
  };
}

function updateProgramLogoError(logoUpdateError) {
  return {
    type: types.UPDATE_PROGRAM_LOGO_ERROR,
    isUpdatingLogo: false,
    logoUpdateError
  };
}

function updateProgramFileRequest() {
  return {
    type: types.UPDATE_PROGRAM_FILE_REQUEST,
    isUpdatingProgramFile: true
  };
}

function updateProgramFileCompleted(updatedProgramFile) {
  return {
    type: types.UPDATE_PROGRAM_FILE_COMPLETED,
    isUpdatingProgramFile: false,
    updatedProgramFile
  };
}

function updateProgramFileError(fileUpdateError) {
  return {
    type: types.UPDATE_PROGRAM_FILE_ERROR,
    isUpdatingProgramFile: false,
    fileUpdateError
  };
}

function updateCertificateRequest() {
  return {
    type: types.UPDATE_CERTIFICATE_FILE_REQUEST,
    isUpdatingCertificate: true
  };
}

function updateCertificateCompleted(updatedCertificate) {
  return {
    type: types.UPDATE_CERTIFICATE_FILE_COMPLETED,
    isUpdatingCertificate: false,
    updatedCertificate
  };
}

function updateCertificateError(certUpdateError) {
  return {
    type: types.UPDATE_CERTIFICATE_FILE_ERROR,
    isUpdatingCertificate: false,
    certUpdateError
  };
}

export function updateProgramLogo(id, file) {
  return (dispatch) => {
    dispatch(updateProgramLogoRequest());
    return api
      .updateLogo(id, file)
      .then(response => {
        if (response.status === 200) {
          logSuccess("Успешно обновлено");
          dispatch(updateProgramLogoCompleted(response.data));
          dispatch(getProgram(id));
          dispatch(getFullProgram(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(updateProgramLogoError(message));
        } else {
          logError(err);
          dispatch(updateProgramLogoError(createError("Не удалось отправить запрос на обновление изображения программы")));
        }
      });
  };
}

export function updateProgramFile(id, file) {
  return (dispatch) => {
    dispatch(updateProgramFileRequest());
    return api
      .updateDocument(id, file)
      .then(response => {
        if (response.status === 200) {
          logSuccess("Успешно обновлено");
          dispatch(updateProgramFileCompleted(response.data));
          dispatch(getFullProgram(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(updateProgramFileError(message));
        } else {
          logError(err);
          dispatch(updateProgramFileError(createError("Не удалось отправить запрос на обновление файла программы")));
        }
      });
  };
}

export function updateCertificate(id, file) {
  return (dispatch) => {
    dispatch(updateCertificateRequest());
    return api
      .updateCertificate(id, file)
      .then(response => {
        if (response.status === 200) {
          logSuccess("Сертификат успешно загружен");
          dispatch(updateCertificateCompleted(response.data));
          dispatch(getFullProgram(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(updateCertificateError(message));
        } else {
          logError(err);
          dispatch(updateCertificateError(createError("Не удалось отправить запрос на обновление файла сертификата")));
        }
      });
  };
}

//! ADD NEW PROGRAM INFORMATION
function addPublishedProgramInfoRequest() {
  return {
    type: types.ADD_NEW_PROGRAM_INFORMATION_REQUEST,
    isCreatingProgram: true
  };
}

function addPublishedProgramResponse(createdProgram) {
  return {
    type: types.ADD_NEW_PROGRAM_INFORMATION_COMPLETED,
    isCreatingProgram: false,
    createdProgram
  };
}

function addPublishedProgramRequestError(createProgramError) {
  return {
    type: types.ADD_NEW_PROGRAM_INFORMATION_ERROR,
    isCreatingProgram: false,
    createProgramError
  };
}

export function addPublishedProgram(data) {
  return dispatch => {
    dispatch(addPublishedProgramInfoRequest());
    return api.addNewProgramInformation(data)
      .then(response => {
        if (response.data.success) {
          dispatch(addPublishedProgramResponse(response.data));
          dispatch(getFullProgram(response.data.id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(addPublishedProgramRequestError(message));
        } else {
          logError(err);
          // dispatch(requestReferenceTypesError(createError("Не удалось загрузить список")));
        }
      });
  };
}

//! UPDATE PROGRAM INFORMATION
function updateProgramInfoRequest() {
  return {
    type: types.UPDATE_PROGRAM_INFORMATION_REQUEST,
    isUpdatingProgram: true
  };
}

function updateProgramResponse(updatedProgram) {
  return {
    type: types.UPDATE_PROGRAM_INFORMATION_COMPLETED,
    isUpdatingProgram: false,
    updatedProgram
  };
}

function updateProgramRequestError(updateProgramError) {
  return {
    type: types.UPDATE_PROGRAM_INFORMATION_ERROR,
    isUpdatingProgram: false,
    updateProgramError
  };
}

export function updateProgram(id, data) {
  console.log(data);
  return dispatch => {
    dispatch(updateProgramInfoRequest());
    return api.updateProgramInformation(id, data)
      .then(response => {
        if (response.data.success) {
          logSuccess("Параметры учебной программы обновлены");
          dispatch(updateProgramResponse(response.data));
          dispatch(getFullProgram(id));
          dispatch(getProgramHtmlDescription(id));
          dispatch(getProgramHtmlAnounce(id));
          dispatch(getProgram(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors
              .map(({ message }) => message)
              .join(", ");
          }
          logError(message);
          dispatch(updateProgramRequestError(err));
        } else {
          let errMessage = "Не удалось обновить программу";
          logError(err);
          dispatch(updateProgramRequestError(createError(errMessage)));
        }
      });
  };
}

export default {
  updateProgramLogo,
  updateProgramFile,
  updateCertificate,
  addPublishedProgram,
  updateProgram
};
